var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTurnoffNotificationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6447_13125)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.4508 13.64C18.9108 12.75 18.5708 11.77 18.4508 10.69L18.2008 8.45001L17.0908 9.57001L17.2408 10.88C17.3808 12.08 17.7708 13.22 18.4308 14.31L19.0108 15.26C19.3408 15.8 19.6808 16.35 19.6608 16.5C19.6508 16.59 19.6008 16.67 19.5308 16.73C19.4108 16.82 18.7508 16.82 18.1108 16.82H9.88078L8.55078 18.16C8.77078 18.93 9.18078 19.62 9.75078 20.12C10.3908 20.68 11.1908 20.99 12.0008 20.99C12.8108 20.99 13.6108 20.68 14.2508 20.12C14.8508 19.59 15.2908 18.85 15.5008 18.03H18.1108C19.2808 18.03 19.8708 18.03 20.3208 17.66C20.6208 17.41 20.8208 17.07 20.8808 16.69C20.9708 16.12 20.6708 15.62 20.0708 14.64L19.4608 13.64H19.4508ZM13.4208 19.23C12.6008 19.95 11.3908 19.95 10.5708 19.23C10.2208 18.93 9.96078 18.51 9.79078 18.04H14.2008C14.0308 18.51 13.7708 18.92 13.4208 19.23Z",
    fill: "#616161"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.48095 16.74C4.41095 16.68 4.36095 16.6 4.35095 16.51C4.33095 16.37 4.67095 15.81 5.00095 15.27L5.61095 14.27C6.24095 13.23 6.63095 12.09 6.78095 10.83L7.03095 8.59001C7.31095 6.10001 9.45095 4.23001 12.001 4.23001C13.421 4.23001 14.701 4.83001 15.611 5.77001L16.481 4.91001C15.341 3.74001 13.761 3.01001 12.001 3.01001C8.82095 3.01001 6.16095 5.35001 5.80095 8.46001L5.54095 10.75C5.42095 11.78 5.08095 12.75 4.52095 13.69L3.94095 14.64C3.34095 15.63 3.04095 16.12 3.13095 16.69C3.19095 17.06 3.38095 17.39 3.67095 17.63L4.56095 16.75C4.56095 16.75 4.50095 16.74 4.49095 16.73L4.48095 16.74Z",
    fill: "#616161"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.64945 20.9904C3.47945 20.9904 3.31945 20.9304 3.18945 20.8004C2.93945 20.5504 2.93945 20.1404 3.18945 19.8804L19.8895 3.19043C20.1395 2.94043 20.5595 2.94043 20.8095 3.19043C21.0595 3.44043 21.0595 3.85043 20.8095 4.11043L4.10945 20.8004C3.97945 20.9304 3.81945 20.9904 3.64945 20.9904Z",
    fill: "#616161"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6447_13125"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(3 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTurnoffNotificationIcon);
export default __webpack_public_path__ + "static/media/turnoffNotificationIcon.c4192604eafca4f8a5ea8fabe020edcd.svg";
export { ForwardRef as ReactComponent };